/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{resolveIncludes as e}from"./sources/resolver.js";const r=e=>e.replace("-","_").toUpperCase(),a=e=>`#define ${r(e)}\n`,t={attributes:new Map([["a_pos",0],["a_tex",1]]),shaders:r=>({vertexShader:a(r)+e("blend/blend.vert"),fragmentShader:a(r)+e("blend/blend.frag")})};export{t as blend};
